// ignore-string-externalization
import styled from 'styled-components';
import { hexToRgba } from '@mrkt/features/color-conversion';
import { white, black, spacer4, spacer8, spacer12, spacer32, spacer40, screenSmMin, screenSmMax, screenXsMax, ButtonIcon } from '@spotify-internal/encore-web';
import { Crossfade } from '../../ui';
import { transformScaleUp } from '../../utils';
export var Carousel = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Carousel",
  componentId: "iqdkks-0"
})(["position:relative;height:", ";&:hover svg{opacity:0.4;display:initial;}"], function (_ref) {
  var tallest = _ref.tallest;
  return "".concat(tallest ? tallest + 50 : 100, "px");
});
export var Splash = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Splash",
  componentId: "iqdkks-1"
})(["position:absolute;height:100%;width:100%;top:0;left:0;background-color:", ";opacity:", ";z-index:", ";transition:opacity 0s 0.5s,z-index 0s 0.5s;"], white, function (_ref2) {
  var tallest = _ref2.tallest;
  return tallest && tallest < 2 ? 1 : 0;
}, function (_ref3) {
  var tallest = _ref3.tallest;
  return tallest && tallest < 2 ? 9999 : -1;
});
export var Slides = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Slides",
  componentId: "iqdkks-2"
})(["height:100%;"]);
export var Slide = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Slide",
  componentId: "iqdkks-3"
})(["position:absolute;overflow:hidden;height:100%;width:100%;", ""], Crossfade);
export var Dots = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Dots",
  componentId: "iqdkks-4"
})(["direction:ltr;position:absolute;bottom:", ";left:", ";display:flex;flex-direction:row;z-index:2;@media (max-width:", "){bottom:", ";left:", ";}@media (min-width:", "){bottom:", ";left:", ";}"], spacer32, spacer40, screenXsMax, spacer32, spacer12, screenSmMin, spacer40, spacer40);
export var Dot = styled.div.withConfig({
  displayName: "ModuleCarouselstyles__Dot",
  componentId: "iqdkks-5"
})(["background:", ";border-radius:50%;width:", ";height:", ";margin-left:", ";margin-right:", ";&:hover{cursor:pointer;}"], function (_ref4) {
  var active = _ref4.active,
      theme = _ref4.theme,
      color = _ref4.color;
  return active ? getDotColor(color || theme.nav.background) : hexToRgba(getDotColor(color || theme.nav.background), 0.25);
}, spacer8, spacer8, spacer4, spacer4);
export var Arrow = styled(ButtonIcon).withConfig({
  displayName: "ModuleCarouselstyles__Arrow",
  componentId: "iqdkks-6"
})(["direction:ltr;position:absolute;top:15%;height:70%;width:", ";color:", ";z-index:2;&::after,&:focus::after{border-bottom:0;}svg{display:none;position:absolute;top:calc(50% - 16px);}&:hover,&:not(:disabled):focus{svg{display:initial;color:", ";", ";&:hover{opacity:1;}}}&:not(:disabled):focus{svg{outline:thin dotted;}}@media (max-width:", "){display:none;}"], spacer32, function (_ref5) {
  var theme = _ref5.theme,
      color = _ref5.color;
  return getDotColor(color || theme.nav.background);
}, function (_ref6) {
  var theme = _ref6.theme,
      color = _ref6.color;
  return hexToRgba(getDotColor(color || theme.nav.background), 0.75);
}, transformScaleUp, screenSmMax);
export var PreviousArrow = styled(Arrow).withConfig({
  displayName: "ModuleCarouselstyles__PreviousArrow",
  componentId: "iqdkks-7"
})(["left:", ";svg{left:0;}"], spacer4);
export var NextArrow = styled(Arrow).withConfig({
  displayName: "ModuleCarouselstyles__NextArrow",
  componentId: "iqdkks-8"
})(["right:", ";width:150px;svg{right:0;}"], spacer4);

function getDotColor(hexColor) {
  // rounds color to black or white based on brightness level
  var color = hexColor.charAt(0) === '#' ? hexColor.substring(1, 7) : hexColor;
  var r = parseInt(color.substring(0, 2), 16);
  var g = parseInt(color.substring(2, 4), 16);
  var b = parseInt(color.substring(4, 6), 16);
  return r * 0.299 + g * 0.587 + b * 0.114 < 125 ? white : black;
}